import {formatDateToString, formatToCurrencyType} from "helper/common";
import moment from "moment";
import React from "react";
import {ColumnsEdit} from "types/models/column-table-edit";
import {FIELD_TYPE, FORMAT_TIME, TT_PHIEU_KHO} from "types/enums";
import {DataFormField} from "types/models/input-field-type";
import {listTTPhieuKho} from "data/list";

const {INPUT, SELECT, DATE_DISABLE, COMBO_BOX} = FIELD_TYPE;

const fields: DataFormField[] = [
  {
    type: INPUT,
    label: "Mã phiếu",
    name: "id",
  },
  {
    type: INPUT,
    label: "Tiêu đề phiếu",
    name: "tieuDe",
  },
  {
    type: COMBO_BOX,
    label: "Kho nhập",
    name: "khoNhapId",
  },
  {
    type: COMBO_BOX,
    label: "Nhà cung cấp",
    name: "nhaCungCapId",
  },

  {
    type: COMBO_BOX,
    label: "Trạng thái",
    name: "status",
    options: listTTPhieuKho,
  },
  {
    type: DATE_DISABLE,
    label: "Từ ngày",
    name: "start",
  },
  {
    type: DATE_DISABLE,
    label: "Đến ngày",
    name: "end",
  },
];

const columns: ColumnsEdit = [
  // {
  //   title: "STT",
  //   dataIndex: "stt",
  //   key: "stt",
  //   render: (value, record, index) => index + 1,
  //   show: true,
  // isResizable: true,
  //   fixed: "left",
  //   align: "center",
  //   width: "4%",
  // },
  {
    title: "Mã phiếu",
    dataIndex: "id",
    key: "id",
    show: true,
    isResizable: true,
    align: "center",
    width: 120,
  },
  {
    title: "Tiêu đề phiếu",
    dataIndex: "tieuDe",
    key: "tieuDe",
    show: true,
    isResizable: true,
    align: "left",
  },

  {
    title: "Kho nhập",
    dataIndex: "khoNhap",
    key: "khoNhap",
    show: true,
    isResizable: true,
    align: "left",
  },
  {
    title: "Nhà cung cấp",
    dataIndex: "nhaCungCap",
    key: "nhaCungCap",
    show: true,
    isResizable: true,
    align: "left",
  },
  {
    title: "Trạng thái phiếu",
    dataIndex: "tinhTrang",
    key: "tinhTrang",
    show: true,
    isResizable: true,
    align: "left",
    render(value, record, index) {
      var tinhTrang;
      switch (value) {
        case TT_PHIEU_KHO.NHAP:
          return "Nháp";
        case TT_PHIEU_KHO.CHO_DUYET:
          return "Chờ duyệt";
        case TT_PHIEU_KHO.DA_DUYET:
          return "Đã duyệt";
        case TT_PHIEU_KHO.HOAN_THANH:
          return "Hoàn thành";
        case TT_PHIEU_KHO.HUY_PHIEU:
          return "Hủy";
        case TT_PHIEU_KHO.TU_CHOI:
          return "Từ chối";
        default:
          break;
      }
    },
  },
  {
    title: "Kho xuất",
    dataIndex: "khoXuat",
    key: "khoXuat",
    show: true,
    isResizable: true,
  },
  {
    title: "Ngày tạo",
    dataIndex: "createDate",
    key: "createDate",
    show: true,
    isResizable: true,
    align: "center",
    render: (text, record) =>
      text ? formatDateToString(text, FORMAT_TIME.dateTime) : "",
  },
  {
    title: "Ngày hoàn thành",
    dataIndex: "ngayHoanThanh",
    key: "ngayHoanThanh",
    show: true,
    isResizable: true,
    align: "center",
    render: (text, record) =>
      text ? formatDateToString(text, FORMAT_TIME.dateTime) : "",
  },
  {
    title: "Người tạo phiếu",
    dataIndex: "nguoiLap",
    key: "nguoiLap",
    show: true,
    isResizable: true,
    align: "left",
  },
  {
    title: "Người giao",
    dataIndex: "nguoiGiao",
    key: "nguoiGiao",
    show: true,
    isResizable: true,
    align: "left",
  },
  {
    title: "Người nhận",
    dataIndex: "nguoiNhan",
    key: "nguoiNhan",
    show: true,
    isResizable: true,
    align: "left",
  },
  {
    title: "Tổng giá trị",
    dataIndex: "tongGiaTri",
    key: "tongGiaTri",
    show: true,
    isResizable: true,
    align: "right",
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Ghi chú",
    dataIndex: "ghiChu",
    key: "ghiChu",
    show: true,
    isResizable: true,
    align: "left",
  },
];

export {fields, columns};
